import { useState } from 'react';
import { Dialog, Button } from '@/design-system';

export interface DeleteConfirmDialogProps {
  open: boolean;
  funnelName: string;
  onClose: () => void;
  onConfirm: () => Promise<void>;
}

/**
 * SPEC-003 §44/DASH-REQ-017/AC-030: explicit confirmation, and the copy
 * never claims permanent deletion (this is a soft delete — DASH-DEC-001).
 */
export function DeleteConfirmDialog({ open, funnelName, onClose, onConfirm }: DeleteConfirmDialogProps) {
  const [submitting, setSubmitting] = useState(false);

  async function handleConfirm() {
    setSubmitting(true);
    try {
      await onConfirm();
      onClose();
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <Dialog open={open} onClose={onClose} title="Excluir funil">
      <p className="mb-4 text-sm text-text-secondary">
        <strong className="text-text-primary">{funnelName}</strong> será removido da área
        principal. Você poderá restaurá-lo pela Lixeira mais tarde.
      </p>
      <div className="flex justify-end gap-2">
        <Button type="button" variant="secondary" onClick={onClose} disabled={submitting}>
          Cancelar
        </Button>
        <Button type="button" variant="danger" onClick={handleConfirm} disabled={submitting}>
          {submitting ? 'Excluindo…' : 'Excluir'}
        </Button>
      </div>
    </Dialog>
  );
}
